import { render } from "./namespace.vue?vue&type=template&id=637b8d5a&scoped=true"
import script from "./namespace.vue?vue&type=script&lang=js"
export * from "./namespace.vue?vue&type=script&lang=js"

import "./namespace.vue?vue&type=style&index=0&id=637b8d5a&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637b8d5a"]])

export default __exports__